import './app/styles/app.css';
import { boot } from './app/boot.js';

boot();
